import { Venue } from '@/components/home/types'
import { User } from './types'

export const newRelicLog = (attributes: NewRelicCustomAttributes, eventType: string): void => {
  if (window.newrelic) {
    switch (eventType) {
      case 'pageAction':
        const name = attributes.name
        delete attributes.name
        window.newrelic.addPageAction(name, attributes)
        break
      default:
        for (let key in attributes) {
          if (attributes.hasOwnProperty(key)) {
            window.newrelic.setCustomAttribute(key, attributes[key])
          }
        }
        window.newrelic.setCustomAttribute('osName', 'webclip')
    }
  }
}

export const newRelicNoticeError = (error: Error, attributes?: Record<string, string | number | boolean>): void => {
  if (typeof window !== 'undefined' && window.newrelic) {
    window.newrelic.noticeError(error, attributes)
  }
}

export const formatGlobalAttributes = (
  user: User | null | undefined,
  venue: Venue | null | undefined,
  tab_uuid: string | null | undefined
) => {
  let newRelicUser = {}
  let newRelicVenue = {}
  let newRelicTab = {}
  if (user?.phone) {
    newRelicUser = {
      customerFirstName: user?.first_name,
      customerLastName: user?.last_name,
      customerPhone: user?.phone,
      customerToken: user?.token,
    }
  }
  if (venue?.venue_uuid) {
    newRelicVenue = {
      venueUUID: venue?.venue_uuid,
      venueName: venue?.name,
      venueMSA: venue?.msa,
    }
  }
  if (tab_uuid) {
    newRelicTab = {
      tabUUID: tab_uuid,
    }
  }
  return { ...newRelicUser, ...newRelicVenue, ...newRelicTab }
}

interface NewRelicCustomAttributes {
  name?: string // atribute name
  duration?: number
  isSuccessful?: string // cast from bool
  venueName?: string
  venueId?: string // uuid
  isScanToPay?: string
  customerId?: number
  itemsIds?: number[]
  [key: string]: string | number | undefined | number[]
}
